import { IGetState, TCardId } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { getCardEstimate } from '../../../../../../../../store/model/selectors/getCardEstimate';
import { cardSetEstimate } from '../../../../../../../../rest/effects/card/card/cardSetEstimate';
import {
    SegmentCardEvent, SegmentCardOptions,
    SegmentCardType
} from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { segmentTrackAction } from '../../../../../../../../middlewares/segment';

export const onChange = (
    cardId: TCardId,
    estimate: number,
    source: SegmentCardType,
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const cardEstimate = getCardEstimate(getState(), cardId);
        if (estimate !== cardEstimate) {
            dispatch(cardSetEstimate(cardId, estimate));
            dispatch(segmentTrackAction(SegmentCardEvent.CHECKLIST_ITEM_ESTIMATE_CHANGED, {
                name: SegmentCardOptions.TYPE,
                value: source
            }));
        }
    };
};
